<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref } from "vue";
import PercentageCard from "./PercentageCard.vue";
import DateCard from "./DateCard.vue";
import { Swiper as SwiperType } from "swiper/types";
import { StageData } from "../types/Stages.Interface";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  contentData: StageData[];
  nextActive: boolean;
  prevActive: boolean;
}>();

const swiperInstance = ref();

const getSwiperInstance = (sw: SwiperType) => {
  swiperInstance.value = sw;

  sw.on("touchMove", () => {});

  sw.on("touchStart", () => {
    sw.slides.forEach((slide) => slide.classList.add("swiper-slide--grabbed"));
  });

  sw.on("touchEnd", () => {
    sw.slides.forEach((slide) => slide.classList.remove("swiper-slide--grabbed"));
  });
};

const emit = defineEmits(["prev", "next"]);

//slide to the first slide and show previous content
const handlePrev = () => {
  emit("prev");
  swiperInstance?.value?.slideTo(0, 1000, true);
};

//slide to the first slide and show next content
const handleNext = () => {
  emit("next");
  swiperInstance?.value?.slideTo(0, 1000, true);
};
</script>

<template>
  <section class="small-box">
    <Swiper
      @swiper="getSwiperInstance"
      :slidesPerView="'auto'"
      :spaceBetween="24"
      :speed="800"
      :updateOnWindowResize="true"
    >
      <SwiperSlide v-for="(content, index) in contentData" :key="index">
        <div class="small-box__slider-card">
          <Picture
            v-if="content?.isImage"
            :devices="content?.image?.devices"
            class="img-absolute"
            alt="construction"
          />
          <DateCard
            class="img-absolute"
            v-if="content?.isDate"
            :date="content?.date"
            :prevActive="prevActive"
            :nextActive="nextActive"
            @prev="handlePrev"
            @next="handleNext"
          />
          <PercentageCard
            class="img-absolute"
            v-if="content?.isPercentage"
            :contentData="content?.percent"
          />
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<style lang="scss">
.small-box {
  &__slider-card {
    position: relative;
    overflow: hidden;
    height: 0;
    transition: all 1.1s cubic-bezier(0.165, 0.84, 0.44, 1);
    @include maxq(mobile) {
      width: 100%;
      height: 100%;
    }
  }
  .swiper {
    overflow: visible;
    height: 100%;
    @include maxq(mobile) {
      width: 100%;
    }
    &-wrapper {
      transition: transform 0.6s cubic-bezier(0.5, 1, 0.89, 1);
    }
    .swiper-slide {
      width: 220px;
      height: 264px;
    }
    .swiper-slide-active {
      position: relative;
    }
  }
}
</style>
